import { PROFILE_FILTER_FIELDS } from '@/constants/profileFilterFields';
import { dropUnknownFields, pruneInactiveNodes } from '@/shared/filters/filter-tree';
import type { FilterGroup } from '@/types/filters';

/**
 * The request the assistant counts its answer with (#697): the one the HNWIs
 * table sends for the same filters, so "N profiles found" is the table total.
 *
 * - held to the user's licence (PI-117), or an admin counts every licence;
 * - the rules the page would drop (a field it does not know) or not send (an
 *   unfinished rule) are left out of the count too;
 * - no keywords: the page clears them when it applies the assistant's filters.
 *
 * Null without a licence: the table loads nothing then, so there is no total
 * to announce.
 */
export function assistantCountPath(
  filters: FilterGroup,
  licenceId: string | null | undefined,
): string | null {
  if (!licenceId) return null;
  let path = `/profiles?page=1&limit=1&license_id=${encodeURIComponent(licenceId)}`;
  const sent = pruneInactiveNodes(dropUnknownFields(filters, PROFILE_FILTER_FIELDS));
  if (sent.children.length > 0) path += `&filters=${encodeURIComponent(JSON.stringify(sent))}`;
  return path;
}
